var canUseDOM = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
);

module.exports = canUseDOM;


/*****************
 ** WEBPACK FOOTER
 ** ./~/can-use-dom/index.js
 ** module id = 375
 ** module chunks = 0
 **/